import UI from "./base/UI";
import {scrollTo} from "../functions/simple.ui";
import gsap, {Linear, Power2, Power4} from 'gsap';
import {CustomEase} from '../libs/gsap/CustomEase.min';
import {getjQueryEl} from "../utils/util";
import {setPosition} from "smooth-scrollbar/scrolling";
import Popup from "./base/Popup";

import {
  isA11yCheckVersion, 
  isA11ySetAttr, 
  isA11yRemoveAttr,
  a11yAcessFocus,
  a11yDebounce,
  isA11yRectList, 
  isA11yButtonRole, 
  isA11yTabButtonRole,
  isA11yAccordion,
  isA11yRecListItem,
} from "../functions/a11y.ui";

import {
  a11yCalendarAccess,
  fcCalendar,
  // fcMoreClearEvent,
  isA11yTabItemsSelected,
  isA11yDateSpinnerInput,
} from "../functions/simple.ui";
/**
 * Widget
 *
 */

class Widget extends UI {
  $dimm;
  $dimmWhite; /*! goToDissolve 함수추가 2025.02.04 (CHPFMTASK-1905) */
  $slider;
  $activeSlide;
  $prevSlide;
  $nextSlide;
  $currentZindex = 100;
  $currentTarget;
  $currentActiveSlide;
  $afterUpdate = null;
  eventAcitve = null
  defaults = {
    index: 0
  };

  constructor(el, options) {
    super('widget', el);

    this.init(el, options);
  }

  init(el, options) {
    gsap.registerPlugin(CustomEase);
    CustomEase.create("customEase", "M0,0 C0.5,0 0.2,1 1,1")
    CustomEase.create("decelerate", "M0,0 C0.42,0 0.2,1 1,1")
    CustomEase.create("accelerate", "M0,0 C0.8,0 0.58,1 1,1")
    this.defaults = {...this.defaults, ...options};

    this.update();
    this.setSlidePosition();

    this.$currentActiveSlide = this.$el.find('.ui-kbank-page-control.activeSlide');
    
    // .dimm이 없을 경우 생성해준다.
    if (!this.$el.find('.dimm')[0]) {
      this.$el.children().prepend(`<div class="dimm"></div>`);
    }

    this.$dimm = this.$el.find('.dimm');
    this.$dimm.css({
      'display': 'none',
      'position': 'fixed',
      'top': '-100px',
      'right': '-100px',
      'bottom': '-100px',
      'left': '-100px',
      'z-index': '100',
      'background': '#000',
      'opacity': '.1'
    });
    this.$slider.css({
      'position': 'fixed',
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0
    });
  }

  update(loaded = false) {
  
    this.$slider = this.$el.find('.ui-kbank-page-control');
    this.$activeSlide = this.$slider.closest('.activeSlide');

    const nowIdx = this.$slider.index(this.$activeSlide);

    this.$prevSlide = this.$slider.eq(nowIdx-1);
    this.$nextSlide = this.$slider.eq(nowIdx+1);
    this.$slider.each(function(idx,el){
      if (!$(el).hasClass('activeSlide')) {
        $(el).css({
          'position': 'fixed',
          'top': 0,
          'left': 0,
          'right': 0,
          'bottom': 0,
          'z-index': 99,
          'transform': 'translate3d(100%, 0px, 0px)'
        });
      } else {
        $(el).css({
          'position': 'fixed',
          'top': 0,
          'left': 0,
          'right': 0,
          'bottom': 0,
        });
      }
    });

    if (loaded !== true) {
      // console.log('loaded  = ', loaded);
      // console.log('이벤트 바인딩 재실행');
      this.detachEvents();
      this.attachEvents();
      // console.log(this.$slider);
      // console.log(this.$activeSlide);
    }

    // A11YTASK-224 fc-more-link 이벤트 막기
    // fcMoreClearEvent();

    /*! s: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 v.1.0.0 */
    this.a11yWidget();
    /*! e: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 v.1.0.0 */

    if (loaded !== true) {
      this.render();
    }

    // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    if (typeof this.$afterUpdate == 'function') { // [CHPFMTASK-258] runCallbackFn이 false일 경우 호출
      if(this.$activeSlide.hasClass('setDone')) return false;
      if(this.$currentTarget && !this.$currentTarget.hasClass('activeSlide')) return false;

      this.$activeSlide.addClass('setDone');
      this.$afterUpdate();
    }
    // e: FETASK-596 업데이트 완료 후 콜백함수 실행

    // if ($('[type-transfer]').length > 0) { // PBKTRN1100000301S.html 사용
    //   this.$slider.toArray().forEach((scrollEl, idx) => {
    //     let _trnasferHeader, _trnasferHeaderH, _trnasferCont;
    //     if (scrollEl.querySelector('[type-transfer]')) {
    //       _trnasferHeader = scrollEl.querySelector('[type-transfer-header]');
    //       _trnasferHeaderH = _trnasferHeader.offsetHeight
    //       _trnasferCont = scrollEl.querySelector('[type-transfer-cont]');
    //       if ($('html').hasClass('ios') && !$('html').hasClass('pc_m') ) {
    //         if ($(window).height() < 812){
    //           _trnasferHeader.style.top = 70 + 'px';
    //           _trnasferCont.style.top = (_trnasferHeaderH + 50 + 20)+'px';  // 50 == header height  20 == 상단
    //         } else {
    //           _trnasferHeader.style.top = 94 + 'px';
    //           _trnasferCont.style.top = (_trnasferHeaderH + 50 + 44)+'px';  // 50 == header height 44 == 상단
    //         }
    //       }  else {
    //         _trnasferHeader.style.top = 50 + 'px';
    //         _trnasferCont.style.top = (_trnasferHeaderH + 50)+'px';  // 50 == header height
    //       }
    //     }
    //   })
    // }
  }

  render() {
    this.$slider.each((index, item) => {
      $(item).attr('data-slide-index', index);
    });

    // A11YTASK-224 fc-more-link 이벤트 막기
    // fcMoreClearEvent();

    /*! s: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 v.1.0.0 */
    this.a11yWidget();
    /*! e: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 v.1.0.0 */
  }

  setSlidePosition(loaded = false) {

    if(this.$afterUpdate){
      this.$afterUpdate =  null;
    }

    // console.log('setSlidePosition loaded = ',loaded);

    this.update(loaded);

    this.$slider.css({
      'z-index': '99',
      'transform': 'translate3d(100%, 0, 0)',
    });

    this.$activeSlide.css({
      'transform': 'translate3d(0, 0, 0)',
      'z-index': '100'
    });
    const nowIdx = this.$slider.index(this.$activeSlide);
    const prevEl = this.$slider.eq(nowIdx-1);
    const nextEl = this.$slider.eq(nowIdx+1);

    nextEl.css({
      'transform': 'translate3d(100%, 0, 0)',
    });

    if (Number(this.$activeSlide.attr('data-slide-index')) != 0) {
      prevEl.css({
        'transform': 'translate3d(-100%, 0, 0)',
      });
    }
    

    // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    const _this = this;
    return {
      done: function(c) {
        if (typeof c == 'function') c(true);
        // _this.afterUpdate(c);
      } 
    }
    // e: FETASK-596 업데이트 완료 후 콜백함수 실행
  }

  /**
   * .activeSlide 기준으로 정렬된다.
   * 1->3 의 경우 1이 이전, 5->2의 경우 5가 이전이 된다.
   * [slide-index] 값을 기준으로 이전,다음을 정하기 때문에 리스트가 동적생성되면(.ui-kbang-page) update()를 해야한다.
   * @param target {id} 문자열 #을 제외한 id
   * @param direction {forward | backward}  [optional] 해당 인자가 있을 경우 방향이 결정됨
   * @example 
   * $('.ui-widget').data('ui').goToSlide('페이지아이디', 'forward');
   */

  goToSlide(target, direction) {
    let value = getjQueryEl('#' + target);

    if(value.attr('id') === undefined) {
      value = getjQueryEl('.' + target);
    }

    // if (value.data('slide-index') === this.$el.find('.activeSlide').data('slide-index')) { 240716  data -> attr  
    //   return {
    //     // activeSlide와 target이 같은 경우 화면전환 없이 콜백함수 실행
    //     done: function(r){
    //       r(true);
    //       return false;
    //     }
    //   };
    // }
    if (value.attr('data-slide-index') == this.$el.find('.activeSlide').attr('data-slide-index')) {  // 240716  data -> attr 
      return {
        // activeSlide와 target이 같은 경우 화면전환 없이 콜백함수 실행
        done: function(r){
          r(true);
          return false;
        }
      };
    }
    // if (!this.$el.hasClass('ing')) {   // 240716  data -> attr 
    //   //this.$el.addClass('ing')  // 다시 주석처리
      
    //   this.$slider.removeClass('activeSlide');
      
    //   value.addClass('activeSlide');
    //   this.$currentTarget = value;
    //   if(direction){
    //     if (direction === 'forward') {
    //       value.css({
    //         'transform': 'translate3d(100%, 0, 0)',
    //       });
  
    //       this.slideNext();
    //     } else if (direction === 'backward') {
    //       value.css({
    //         'transform': 'translate3d(-100%, 0, 0)',
    //       });
  
    //       this.$currentActiveSlide = this.$activeSlide;
    //       this.$activeSlide = this.$currentTarget;
    
    //       this.slidePrev();
    //     }
    //   }else {
    //     if (this.$activeSlide.data('slide-index') < value.data('slide-index')) {
    //       value.css({
    //         'transform': 'translate3d(100%, 0, 0)',
    //       });
  
    //       this.slideNext();
    //     } else if (this.$activeSlide.data('slide-index') > value.data('slide-index')) {
    //       value.css({
    //         'transform': 'translate3d(-100%, 0, 0)',
    //       });
  
    //       this.slidePrev();
    //     }
    //   }
    // }
    if (!this.$el.hasClass('ing')) {    // 240716  data -> attr 
      //this.$el.addClass('ing')  // 다시 주석처리
      
      this.$slider.removeClass('activeSlide');                                
      
      value.addClass('activeSlide');
      this.$currentTarget = value;
      if(direction){
        if (direction === 'forward') {
          value.css({
            'transform': 'translate3d(100%, 0, 0)',
          });
  
          this.slideNext();
        } else if (direction === 'backward') {
          value.css({
            'transform': 'translate3d(-100%, 0, 0)',
          });
  
          this.$currentActiveSlide = this.$activeSlide;
          this.$activeSlide = this.$currentTarget;
    
          this.slidePrev();
        }
      }else {
        //if (this.$activeSlide.attr('data-slide-index') < value.attr('data-slide-index')) {
        if (Number(this.$activeSlide.attr('data-slide-index')) < Number(value.attr('data-slide-index'))) {
          value.css({
            'transform': 'translate3d(100%, 0, 0)',
          });
  
          this.slideNext();
        } else if (Number(this.$activeSlide.attr('data-slide-index')) > Number(value.attr('data-slide-index'))) {
          value.css({
            'transform': 'translate3d(-100%, 0, 0)',
          });
  
          this.slidePrev();
        }
      }
    }
    
    // this.update();
    //이동 전 슬라이드 위치 초기화
    // this.setSlidePosition();
    if (this.$currentTarget.find('[data-ani-count]').length > 0 ) {
      frontUI.numberCountAni() // FETASK-1641 팝업에  숫자 카운팅 있을때 재실행
    }
    
    frontUI.aniDelay(value); // FETASK-1261 : 230810 추가
    if ($('[data-role="animation-group"]').length > 0) { //FETASK-1555  : 위젯 이동시  스크롤 애니메이션 초기화  조건 data-auto-reset="true"
      this.$slider.each(function(idx,slide){
        if (!$(slide).hasClass('activeSlide')) {
          $('[data-role="animation-group"]').each(function(idx,animationGroup){
            if ($(animationGroup).attr('data-auto-reset') == 'true') {
              $(animationGroup).data('ui').resetClass()
            }
          }) 
        }
      })
    }
    //FETASK-1555  : 위젯 이동시  스크롤 애니메이션 초기화  조건 data-auto-reset="true"
    if (this.$currentTarget.find('[data-role="animation-group"]').length > 0 && this.$currentTarget.find('[data-role="animation-group"]').attr('data-auto-reset') == 'true') { 
      this.$currentTarget.find('[data-role="animation-group"]').data('ui').render()
    }
    
    // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    const _this = this;
    return {
      done: function(c) {
        _this.afterUpdate(c);
      } 
    }
    // e: FETASK-596 업데이트 완료 후 콜백함수 실행


  }
  

  slidePrev() {
    gsap.killTweensOf(this.$dimm);
    gsap.killTweensOf(this.$slider);
    gsap.killTweensOf(this.$currentActiveSlide);
    let displayText = 'block'
    if ($('.kbank-page-PBKTRN1100000301S_M04').length > 0) {
      if (this.$currentTarget.hasClass('kbank-page-PBKTRN1100000301S_M04')) {
        displayText = 'none'
      } else {
        displayText = 'block'
      }
    }

    gsap.fromTo(this.$dimm,
      {display: displayText, autoAlpha: 0, zIndex: this.$currentZindex + 1},
      {duration: .4, autoAlpha: 0.1, ease: 'customEase', onComplete: () => {
        if(this.$currentTarget[0] === this.$activeSlide[0]){
          gsap.fromTo(this.$currentActiveSlide, {x:0, zIndex:this.$currentZindex + 1},{duration: .3, x: 100 + '%', ease: 'customEase'});
        }
        // this.$currentTarget.css({'z-index': this.$currentZindex + 1});
        // this.$activeSlide.css({'z-index' : this.$currentZindex - 1});
      }}, 0);

    // if(this.$currentTarget[0] === this.$activeSlide[0]){
      // gsap.fromTo(this.$activeSlide, {x:0, zIndex:this.$currentZindex + 1},{duration: .1, x: 100 + '%', ease: 'customEase'});
    // }

    gsap.fromTo(this.$currentTarget,{x:-20+'%', zIndex:this.$currentZindex - 1}, {
      duration: .3, x: 0, ease: 'customEase', onComplete: () => {
        gsap.to(this.$dimm, {duration:.3, display: 'none', autoAlpha: 0, zIndex: this.$currentZindex});
      
        if(this.$currentTarget[0] === this.$activeSlide[0]){
          this.$currentActiveSlide.css({'transform': 'translate3d(100%, 0, 0)'});
        }
        this.update();
        setTimeout( () => { 
          this.$el.removeClass('ing')
        },100)
      }
    });
    // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    const _this = this;
    return {
      done: function(c) {
        _this.afterUpdate(c);
      } 
    }
    // e: FETASK-596 업데이트 완료 후 콜백함수 실행
  }

  slideNext() {
    const aniDuration = this.$currentTarget.attr('data-widget-duration') !== undefined ? Number(this.$currentTarget.attr('data-widget-duration') * 0.001) : .3;
    const currentIndex = aniDuration === 0 && frontUI.Popup.isOpenPopup() ? (frontUI.Popup.zIndex + 5) : this.$currentZindex;
    gsap.killTweensOf(this.$dimm);
    gsap.killTweensOf(this.$slider);
    gsap.killTweensOf(this.$activeSlide);
    //FETASK-754  반팝업 -> 풀팝업 dim 안보이게
    let displayText = 'block'
    if ($('.kbank-page-PBKTRN130000A100V_3').length > 0) {
      if (this.$currentTarget.hasClass('kbank-page-PBKTRN130000A100V_3')) {
        displayText = 'none';
      } else {
        displayText = 'block'
      }
    }
    gsap.fromTo(this.$dimm,
      {display: displayText, autoAlpha: 0, zIndex: this.$currentZindex + 1},
      {duration: (aniDuration+0.1), autoAlpha: 0.1, ease: 'customEase', onComplete: () => {
          this.$currentTarget.css({'z-index': currentIndex + 1});
          this.$activeSlide.css({'z-index' : this.$currentZindex - 1});
          setTimeout(() => {
            this.$currentTarget.css({'z-index': this.$currentZindex + 1});
          }, 500)
        }}, 0);


    if(this.$currentTarget == this.$activeSlide){
      gsap.fromTo(this.$activeSlide,{x:0}, {duration: aniDuration, x: -20 + '%', ease: 'customEase'});
    }

    gsap.fromTo(this.$currentTarget, {x: 100 + '%'}, {
      duration: aniDuration, x: 0, ease: 'customEase', onComplete: () => {
        gsap.to(this.$dimm, {display: 'none', autoAlpha: 0, zIndex: this.$currentZindex});
        if(this.$currentTarget == this.$activeSlide){
          this.$activeSlide.css({'transform': 'translate3d(-100%, 0, 0)'});
        }
        setTimeout(() => {
          this.update();
        }, (0.3 - aniDuration))
        if (this.$currentTarget.find('[data-ani-count][ani-count-scroll]').length > 0) {frontUI.numberCountAniScroll()}// FETASK-1594 
        setTimeout( () => { 
          this.$el.removeClass('ing')
        },100)
      }
    });
    
    // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    const _this = this;
    return {
      done: function(c) {
        _this.afterUpdate(c);
      } 
    }
    // e: FETASK-596 업데이트 완료 후 콜백함수 실행
  }
  /*! S: goToDissolve 함수추가 2025.02.04 (CHPFMTASK-1905) */
  dissolveAction() {
    const aniDuration = this.$currentTarget.attr('data-widget-duration') !== undefined ? Number(this.$currentTarget.attr('data-widget-duration') * 0.001) : .5;
    const currentIndex = aniDuration === 0 && frontUI.Popup.isOpenPopup() ? (frontUI.Popup.zIndex + 5) : this.$currentZindex;
    gsap.killTweensOf(this.$dimmWhite);
    gsap.killTweensOf(this.$slider);
    gsap.killTweensOf(this.$activeSlide);
    
    gsap.fromTo(this.$dimmWhite,
      {autoAlpha: 0, zIndex: this.$currentZindex + 2},
      {autoAlpha: 1, duration: .4, ease: 'decelerate', onComplete: () => {
        this.$currentTarget.css({'z-index': currentIndex});
        this.$activeSlide.css({'z-index' : this.$currentZindex - 1});
      }});

    gsap.fromTo(this.$currentTarget, 
      {display: 'none', zIndex:this.$currentZindex + 1}, 
      {display: 'block', duration: .4, onComplete: () => {
        gsap.to(this.$dimmWhite, 
          {duration: .4, autoAlpha: 0, ease: 'accelerate', zIndex: this.$currentZindex, display: 'none'});
          setTimeout(() => {
            this.update();
          },(0.4 - aniDuration))
      }
    });
    
    // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    // const _this = this;
    // return {
    //   done: function(c) {
    //     _this.afterUpdate(c);
    //   } 
    // }
    // e: FETASK-596 업데이트 완료 후 콜백함수 실행
  }
  /*! E: goToDissolve 함수추가 2025.02.04 (CHPFMTASK-1905) */

  /**
  * 업데이트 완료 후 콜백함수 
  * @param func {function} 콜백함수
  * @example 
  * $('.ui-widget').data('ui').afterUpdate(function(){});
  */
  afterUpdate(func) { // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    if (typeof func == 'function') {
      this.$afterUpdate = func;
    }
  }

/**
 * Top 버튼 관련 공통 가이드
 * - 해당요소에 data-scroll-top 속성 적용
 * - {boolean} scroll-top-action  속도 제어 여부
 * - {value} scroll-top-speed 기본: 300, 애니메이션 속도
 * - {easing} cubicBez함수 : 애니메이션 효과 커스텀 함수
 * 
 * @example
 * <button class="btn-scroll-top" type="button" data-scroll-top>
 *    <i class="ico-arrow-up" aria-hidden="true"></i>
 *    <span class="hide-txt">맨 위로 이동</span>
 * </button>
 * 
 * $(_this).stop().animate({
 *    scrollTop: 0
 *    }, 300, $.cubicBez([0.42, 0, 0.58, 1])
 * );
*/
  attachEvents() {
    if(!this.$slider){
      return;
    }
    let offsetWrapArr = []
    let offsetScrolling = [] // FETASK-1915
    const _hederH = this.$slider.find('.component-header').outerHeight(true);
    let delteListPosTop,delteListScrChk = false, delteListChk = false, $showList,showListOffTop; // FETASK-246 ui-deleteList  스크롤시  보여주기 옵션

    // console.log('attachEvents', this.$slider);
    
    if ($('.ui-deleteList').length > 0) {// FETASK-246 ui-deleteList  스크롤시  보여주기 옵션
      delteListPosTop = $('.ui-deleteList').offset().top;
      $('.ui-deleteList').attr('call-check',delteListChk)
      $('.ui-deleteList').attr('scroll-check',delteListScrChk)
    }
    this.$slider.toArray().forEach((scrollEl, idx) => {
      if (scrollEl.querySelector('.page-inner-scroll .component-meet-info-wrap')) {
        offsetWrapArr.push(scrollEl.querySelector('.page-inner-scroll .component-meet-info-wrap').offsetTop)
      }else {
        offsetWrapArr.push(0)
      }
      if (scrollEl.querySelector('.page-inner-scroll [data-scrolling-offset]')) { // FETASK-1915
        offsetScrolling.push(scrollEl.querySelector('.page-inner-scroll [data-scrolling-offset]').offsetTop)
      }else {
        offsetScrolling.push(0)
      }
      scrollEl.querySelector('.page-inner-scroll')
       && scrollEl.querySelector('.page-inner-scroll').addEventListener('scroll', (e) => {
        const _this = e.target;
        if(_this.scrollTop > 0){
          _this.classList.add('scrolling');
        }else{
          _this.classList.remove('scrolling')
        }
        if ($(_this).attr('data-scrolling-class') != undefined) { // FETASK-1915
          const _className = $(_this).attr('data-scrolling-class');
          if (_this.scrollTop > offsetScrolling[idx] - _hederH) {
            $(_this).find('[data-scrolling-target]').hasClass(_className) ? '' : $(_this).find('[data-scrolling-target]').addClass(_className);
          } else {
            $(_this).find('[data-scrolling-target]').hasClass(_className) ? $(_this).find('[data-scrolling-target]').removeClass(_className) : '';
          }
        }
        if ($(_this).find('.component-meet-info-wrap').length > 0) { // FETASK-1058 | 모임통장에서 입출금내역 들어갈 경우 문제 $(_this) 추가
          if (_this.scrollTop > offsetWrapArr[idx] - _hederH) {
            $(_this).find('.component-header').addClass('page-bg-white');
            $(_this).find('.component-meet-info-wrap').addClass('active');
            $(_this).closest('.ui-kbank-page-control').addClass('page-bg-white');
            //FETASK-982 : 상단 white 삭제
            // setTimeout(()=>{
            //   $(_this).find('.component-header .ico-back').removeClass('white')
            //   $(_this).find('.component-header .ico-alarm').removeClass('white')
            //   $(_this).find('.component-header .ico-set').removeClass('white')
            // }, 50)
          } else {
            $(_this).find('.component-header').removeClass('page-bg-white');
            $(_this).find('.component-meet-info-wrap').removeClass('active');
            $(_this).closest('.ui-kbank-page-control').removeClass('page-bg-white');
            //FETASK-982 : 상단 white 삭제
            // setTimeout(()=>{
            //   $(_this).find('.component-header .ico-back').addClass('white')
            //   $(_this).find('.component-header .ico-alarm').addClass('white')
            //   $(_this).find('.component-header .ico-set').addClass('white')
            // }, 50)
          }
        }
        if ($(_this).find('[data-scroll-class]').length > 0) {
          if (!$(_this).hasClass($(_this).find('[data-scroll-class]').attr('data-scroll-class'))) {
            $(_this).addClass($(_this).find('[data-scroll-class]').attr('data-scroll-class'))
          }
        }

        if ($(_this).find('.scroll-tooltip').length > 0) { //FETASK-917 | 230427 |  FPMCRD0300000301S 하단 버튼 스크롤 닿으면 이벤트
          const _height = $(_this).find('.container-component').outerHeight(true)
            if (_this.scrollTop + $(_this).height() > _height - $(_this).find('.fixed-bottom').outerHeight(true)){
                $(_this).find('.scroll-tooltip').addClass('scrollAni')
            } else {
                $(_this).find('.scroll-tooltip').removeClass('scrollAni')
            }
        }
        if ($(scrollEl).attr('type-delete-list') != undefined){ // FETASK-246 ui-deleteList  스크롤시  보여주기 옵션
          $showList = $('.ui-deleteList').find('input').not(':checked').eq(0).closest('.ui-del-list');
          if ($('.ui-deleteList').attr('scroll-check') == 'false') {
            delteListScrChk = true;
            $('.ui-deleteList').attr('scroll-check',delteListScrChk);
            // checkbox true 제외 false 첫번째 요소
            if ($showList.length > 0) {
              showListOffTop = $showList.offset().top;
            }
          }
          if ($showList.length > 0 && _this.scrollTop + $(window).height() > showListOffTop + 100) {
            if ($('.ui-deleteList').attr('call-check') == 'false') {
              delteListChk = true;
              $showList.addClass('call');
              $('.ui-deleteList').attr('call-check',delteListChk);
            }
          }
        }

        if ($(_this).find('[data-scroll-top]').length > 0) { // CHPFMTASK-701
          var $scrollTopBtn = $(_this).find('[data-scroll-top]');
          if (_this.scrollTop > $(window).height() * 1.8) {
            if (!$scrollTopBtn.hasClass('active')) {
              $scrollTopBtn.addClass('active');
              // $scrollTopBtn.css({
              //   opacity : 0,
              //   display: 'block'
              // }).stop().animate({
              //   opacity : 1
              // })

              $scrollTopBtn.off('click').on('click', function(){
                if ($(_this).find('[data-scroll-top]').attr('scroll-top-action') == 'true') {
                  var $topSpeed = $(_this).find('[data-scroll-top]').attr('scroll-top-speed')
                  var speed = $topSpeed == undefined || $topSpeed == '' ? 300 : Number($topSpeed);

                  // $(_this).stop().animate({scrollTop: 0}, speed);
                  // KDS interaction guide : Scroll To Top
                   // CHPFMTASK-2017 : easing, duration 적용 (2025.03.11)
                  $(_this).stop().animate({
                    scrollTop: 0
                  }, speed, $.cubicBez([0.42, 0, 0.58, 1]));
                } else{
                  // $(_this).scrollTop(0);
                  // KDS interaction guide : Scroll To Top
                  // CHPFMTASK-2017 : easing, duration 적용 (2025.03.11)
                  $(_this).stop().animate({
                    scrollTop: 0
                  }, 300, $.cubicBez([0.42, 0, 0.58, 1]));
                }
              })
            }
          } else {
            if ($scrollTopBtn.hasClass('active')) {
              $scrollTopBtn.removeClass('active');
              // $scrollTopBtn.stop().animate({
              //   opacity : 0
              // }, function(){
              //   $scrollTopBtn.css('display', 'none')
              // })
            }
          }
        }
        if ($(_this).find('[data-scroll-action]').length > 0) { // CHPFMTASK-958
          if (_this.scrollTop + $(window).height() / 3> offsetScrolling[idx] - _hederH && !$(_this).find('[data-scroll-action]').hasClass('on')) {
            $(_this).find('[data-scroll-action]').addClass('on');
            $(_this).find('[data-scroll-action]').data('ui').run();
          }
        }

        //CHPFMTASK-2128 : 스티키 고정되었을 때 라인 (2025.04.09)
        if ($(_this).find('[data-sticky-border]').length > 0) {
          const csEl = $(_this).find('[data-sticky-border]');
          const componentHeaderHeight = $(_this).find('.component-header').height()
          console.log('csOffsetTop',csEl.offset().top)
          console.log('componentHeaderHeight',componentHeaderHeight)
          if (csEl.offset().top == componentHeaderHeight){
            csEl.addClass('stick')
          } else {
            csEl.removeClass('stick')
          }
        }

      }, {passive: true})  //{passive: true}
    })
    //this.setBgColor()
  }

  detachEvents() {
    this.$el.off(this.eventId);
  }

  /**
   * 최초 페이지 로드시 첫번째가 activeSlide가 아닌 경우
   * @param target {id} 문자열 #을 제외한 id
  */
  setSlideActive(target){
    const page = getjQueryEl('#' + target).length > 0 ? getjQueryEl('#' + target) : getjQueryEl('.' + target);

    if (page.attr('data-slide-index') === this.$el.find('.activeSlide').attr('data-slide-index')) { // 240716  data -> attr 
      return {
        done: function(r){
          r(true);
          return false;
        }
      };
    }

    this.$slider.removeClass('setDone');   
    this.$slider.removeClass('activeSlide');
    page.addClass('activeSlide');

    return this.setSlidePosition(true);
  }

  destroy() {
    this.detachEvents();
  }

  setBgColor(){
    const _$activeSlide = this.$slider.closest('.activeSlide');
    if (_$activeSlide.find('.card-layout-group[class*="bg-"]').length > 0){
      var _height = _$activeSlide.find('.card-layout-group[class*="bg-"]').outerHeight(true);
      var _bgColor = frontUI.rgb2hex(_$activeSlide.find('.card-layout-group[class*="bg-"]').css('background-color'));
      var classArr = _$activeSlide.find('.card-layout-group[class*="bg-"]').attr('class').split(' ');
      for (var i = 0; i < classArr.length; i++) {
        if (classArr[i].includes('bg-')) {
          _$activeSlide.addClass(classArr[i])
          //_$activeSlide.css('background', `linear-gradient(to bottom, ${_bgColor} ${_height}px, #fff ${_height+10}px)`)
        }
      }
    }
  }

  /*! s: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 v.1.0.0 */
  a11yWidget(){
    requestAnimationFrame(() => {
      //DOM 컨텐츠 모두 load된 뒤에 실행 스크린리더 속성 및 focus로직
      const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행
      
      if(isA11yCheck){
        const slidesEle = document?.querySelectorAll('.ui-kbank-page-control');
        const curActiveNum = this.$slider.index(this.$activeSlide);
        const nonActiveEle = Array.from(slidesEle)?.filter((item, idx) => idx !== curActiveNum && item);

        const activeItem = document.querySelector('.activeSlide');

        nonActiveEle?.forEach((item) => {
          item.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
        });
        
        if(activeItem){
          activeItem.setAttribute('aria-hidden', 'false');
          activeItem.removeAttribute('tabindex');
        }

        const toggleItemEles = this.$el[0].querySelectorAll('.ui-ToggleRadio.input-radio-btn-area .toggle-item input');

        isA11ySetAttr(toggleItemEles,'aria-hidden', 'true');

        //chatbot 버튼 막히는현상 수정
        const chatbotBtns = document?.querySelectorAll('.btn-chatbot');
        isA11yRemoveAttr(chatbotBtns,'tabindex');
        isA11yRemoveAttr(chatbotBtns,'aria-hidden');

        //내계좌(최근에 보낸 계좌) 삭제버튼 접근성 추가
        isA11yRectList();

        //버튼 접근성
        isA11yButtonRole();

        //tab 접근성
        isA11yTabButtonRole();

        //아코디언 접근성
        isA11yAccordion();

        //fcCalendar
        fcCalendar();
        a11yCalendarAccess();

        //Tab, SubTab
        isA11yTabItemsSelected();

        isA11yRecListItem();

        isA11yDateSpinnerInput();
        
        setTimeout(() => {
          const newArrPopup = [...new Set(Popup.arrPopup)];

          //console.log('widget data-auto-focus', $(this.$activeSlide)?.find('[data-auto-focus="true"]'));
          //console.log('widget data-auto-focus', $(this.$activeSlide)?.find('[data-auto-focus="true"]')?.length);

          if(!newArrPopup?.length){
            Popup.a11yDetctClosePopup();

            a11yAcessFocus(this.$activeSlide[0], false);
          }
        },600);
      }
    });
  }
  /*! e: FETASK-a11y page 위젯 스크린리더 속성 및 focus로직 적용상세 v.1.0.0 */

  /*! S: goToDissolve 함수추가 2025.02.04 (CHPFMTASK-1905) */

    /**
   * 현재 페이지가 A 이동해 갈 페이지가 B라고 가정했을 때
   * A 페이지에서 goToDissolve(B) 함수 호출 시 A 페이지 위로 white dim이 opacity 0 > 1 되는 모션이 0.5초간 노출되고 A 페이지에서 activeSlide가 제거됩니다.
   * B 페이지에 activeSlide 클래스 추가되면서 B 페이지 위로 white dim이 opacity 1 > 0 되는 모션이 0.5초간 노출되며 페이지 이동이 완료됩니다.
   * @param target {id} 문자열 #을 제외한 id
   * @example 
   * $('.ui-widget').data('ui').goToDissolve('페이지아이디');
   */

  goToDissolve(target) {
    console.log('goToDissolve')
    // .dimm_white가 없을 경우 생성해준다.
    if (!this.$el.find('.dimm_white')[0]) {
      // this.$el.children().find('.dimm').remove();
      this.$el.children().prepend(`<div class="dimm_white"></div>`);
    }
    this.$dimmWhite = this.$el.find('.dimm_white');
    this.$dimmWhite.css({
      'display': 'block',
      'position': 'fixed',
      'top': '-100px',
      'right': '-100px',
      'bottom': '-100px',
      'left': '-100px',
      'z-index': '100',
      'background': '#fff',
      'opacity': '0'
    });

    let value = getjQueryEl('#' + target);
  
    if(value.attr('id') === undefined) {
      value = getjQueryEl('.' + target);
    }
  
    if (value.attr('data-slide-index') == this.$el.find('.activeSlide').attr('data-slide-index')) {  // 240716  data -> attr 
      return {
        // activeSlide와 target이 같은 경우 화면전환 없이 콜백함수 실행
        done: function(r){
          r(true);
          return false;
        }
      };
    }
    if (!this.$el.hasClass('ing')) {    // 240716  data -> attr 
      setTimeout(() => {
        value.css({
          'transform': 'translate3d(0, 0, 0)',
        });
        this.$slider.removeClass('activeSlide');   
        value.addClass('activeSlide');     
      }, 350)
      this.$currentTarget = value;
      this.dissolveAction();
    }
    
    frontUI.aniDelay(value); // FETASK-1261 : 230810 추가
    if ($('[data-role="animation-group"]').length > 0) { //FETASK-1555  : 위젯 이동시  스크롤 애니메이션 초기화  조건 data-auto-reset="true"
      this.$slider.each(function(idx,slide){
        if (!$(slide).hasClass('activeSlide')) {
          $('[data-role="animation-group"]').each(function(idx,animationGroup){
            if ($(animationGroup).attr('data-auto-reset') == 'true') {
              $(animationGroup).data('ui').resetClass()
            }
          }) 
        }
      })
    }
    //FETASK-1555  : 위젯 이동시  스크롤 애니메이션 초기화  조건 data-auto-reset="true"
    if (this.$currentTarget.find('[data-role="animation-group"]').length > 0 && this.$currentTarget.find('[data-role="animation-group"]').attr('data-auto-reset') == 'true') { 
      this.$currentTarget.find('[data-role="animation-group"]').data('ui').render()
    }
    
    // s: FETASK-596 업데이트 완료 후 콜백함수 실행
    const _this = this;
    return {
      done: function(c) {
        _this.afterUpdate(c);
      } 
    }
    // e: FETASK-596 업데이트 완료 후 콜백함수 실행
  }
  /*! E: goToDissolve 함수추가 2025.02.04 (CHPFMTASK-1905) */
}

export default Widget;